$(function() {
	var firstLoad = true;

	$('.tab a').on('click', function(event) {
		event.preventDefault();

		if (!$(this).hasClass('active')) {

			$('.tab a').removeClass('active');
			$(this).addClass('active');

			if (!firstLoad) {
				$('.filter-tab-content').fadeOut('fast');
			} else {
				firstLoad = !firstLoad;
			}

			var tab = $(this).attr('href');
			$(tab).fadeIn();
			//window.location.hash = tab;
		}
	});

	$('ul.tabs').tabs({
		'onShow': function() {
			
			$('.slick-slider').each(function() {
				$(this).slick('refresh');
			});
		}
	});
});


/** WEBPACK FOOTER **
 ** ./Frontend/js/modules/tabs/index.js
 **/